// AI models and monthly AI-reply usage. The OpenAI key is a server secret — the browser never sees one.
import { apiClient } from "../apiClient";

/** -> { models:[{id,label,description,minPlan,available}], plan, defaultModel } */
export const getAiModels = () => apiClient("/api/ai/models").then((res) => ({ models: res.data, plan: res.meta.plan, defaultModel: res.meta.default }));
/** -> { plan, periodLabel, resetsOn, used, quota, remaining, percent, status: ok|warning|exceeded, byBot[] } */
export const getAiUsage = () => apiClient("/api/ai/usage").then((res) => res.data);
